/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Legacy_Caption_SingleInputs */

const vi_carrier_legacy_caption_single = /** @type {(inputs: Carrier_Legacy_Caption_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tự động`)
};

/**

* @param {Carrier_Legacy_Caption_SingleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_legacy_caption_single = /** @type {((inputs?: Carrier_Legacy_Caption_SingleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Legacy_Caption_SingleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_legacy_caption_single(inputs)
});